/* eslint-disable import/prefer-default-export */
export function formatPath(path) {
  let link = path;
  if (path.charAt(0) !== '/') {
    link = `/${path}`;
  }

  return link;
}
/* eslint-disable import/prefer-default-export */
export function stripDomainAndLeadingSlash(url) {
    try {
        const parsed = new URL(url);
        return parsed.pathname.replace(/^\/+/, '') + parsed.search + parsed.hash;
    } catch {
        return url;
    }
}